<template>
  <div style="background: white;">
    <div class="grid">
      <div class="col1" @click="chooseMember(-1)" :class="[(m_column===-1)?'choose-col': 'nochoose-col']">
        <span :class="[(m_column===-1)?'tag': 'tag_2']" :lines="undefined">全部成员</span>
      </div>
      <div class="col2" v-for="(member,i) in memberList" @click="chooseMember(i)" :class="[(m_column===i)?'choose-col': 'nochoose-col']">
        <span :class="[(m_column===i)?'tag': 'tag_2']" :lines="undefined">{{ member }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import EMKT from '../constant.js'

export default {
  data () {
    return {
      emkt: EMKT,
      m_column: -1,
      currentSelectionName: []
    }
  },
  props: {
    memberList: {
      type: Array,
      default: []
    }
  },
  emits: ['updateSelection'],
  methods: {
    chooseMember: function (mcolumn) {
      this.m_column = mcolumn
      if (mcolumn !== -1) {
        this.currentSelectionName = [this.memberList[this.m_column]]
      } else {
        this.currentSelectionName = []
      }
      this.$emit('updateSelection', this.currentSelectionName)
    }
  }
}
</script>

<style scoped>

.grid {
  display: flex;
  flex-shrink: 0;
  position: relative;
  align-items: center;
  align-self: center;
  flex-direction: row;
  flex-wrap: wrap;
}

.col1 {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin: 5px;
  border-radius: 10px;
  width: fit-content;
  height: 22px;
  padding: 0 10px;
}

.tag {
  opacity: 1;
  /*max-width: 23.73vw;*/
  /*height: 5.33vw;*/
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 22px;
  white-space: nowrap;
  color: #5878fa;
  font-size: 12px;
  font-weight: 400;
}

.col2 {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin: 5px;
  border-radius: 10px;
  background-color: #efeef3;
  width: fit-content;
  height: 22px;
  padding: 0 10px;
}

.choose-col {
  border-width: 1px !important;
  border-style: solid !important;
  border-color: rgba(88, 120, 250, 1) !important;
  background-color: rgba(88, 120, 250, 0.15) !important;
}

.nochoose-col {
  background-color: #efeef3 !important;
}

.tag_2 {
  opacity: 1;
  /*max-width: 23.73vw;*/
  /*height: 5.33vw;*/
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 22px;
  white-space: nowrap;
  color: #424242;
  font-size: 12px;
  font-weight: 400;
}
.tag {
  opacity: 1;
  text-align: center;
  line-height: 22px;
  white-space: nowrap;
  color: #5878fa;
  font-size: 12px;
  font-weight: 400;
}

</style>



// WEBPACK FOOTER //
// GcSingleSelection.vue?1336bcb8